import * as React from "react"
import PropTypes  from "prop-types"

export default class LoginComponent extends React.Component {
	render() {
		const names      = { username: "username", password: "password" }
		const { submitting, isError } = this.props
		return (
			<div className="hero is-fullheight">
				<div className="hero-body">
					<div className="container">
						<div className="columns">
							<form className="column is-4 is-offset-4" onSubmit={this.props.onSubmit}>

								<div className="field">
									<label className="label" htmlFor={names.username}>Adresse e-mail</label>
									<div className={`control has-icons-left ${submitting ? "is-loading": ""}`}>
										<input
										className   = "input"
										disabled    = {submitting}
										name        = {names.username}
										placeholder = "contact@sfp-collectivites.fr"
										type        = "email"
										required />
										<span className="icon is-left"><i className="fas fa-envelope"></i></span>
									</div>
								</div>

								<div className="field">
									<label className="label" htmlFor={names.password}>Mot de passe</label>
									<div className={`control has-icons-left ${submitting ? "is-loading": ""}`}>
										<input
										className   = "input"
										disabled    = {submitting}
										name        = {names.password}
										placeholder = "Mot de passe"
										type        = "password"
										required />
										<span className="icon is-left"><i className="fas fa-lock"></i></span>
									</div>
								</div>

								<p><button className={`button is-primary ${submitting ? "is-loading": ""}`} disabled={submitting}>Connexion</button></p>
							</form>
						</div>
						{isError && <div className="column is-12 error-text">Connexion échoué</div>}
					</div>
				</div>
			</div>
		);
	}
}

LoginComponent.propTypes = {
	submitting: PropTypes.bool.isRequired,
	onSubmit  : PropTypes.func.isRequired,
};


// WEBPACK FOOTER //
// ./src/route/login/login-component.js